import { createSlice } from "@reduxjs/toolkit";
import Immu from "utils/immu-util";
import { handleErrorStopLoading, handleLoading } from "redux/redux-util";
import { DefaultPaginable, routerChangeAction, Routes } from "const";
import moment from "moment-timezone";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
  loading: false,
  histories: [],
  filterTransactionDate: [moment().subtract(3, "month"), moment()],
  paginable: { ...DefaultPaginable },
  endPaging: false,
  total: 0,
};

const slice = createSlice({
  initialState,
  name: "structureNoteHistories",
  extraReducers: (builder) => {
    builder.addCase(routerChangeAction, (state, { payload }) => {
      state.prevPathname = state.currPathname;
      state.currPathname = payload.location.pathname;
      state.goBackFromCustomerInfoPage = state.prevPathname === Routes.Register.CustomerInfo;
    });
  },
  reducers: {
    getHistory: handleLoading,
    getHistorySuccess: (state, action) => {
      state.loading = false;
      // state.histories = action.payload.histories
      state.histories = [...state.histories, ...action.payload.histories];
      state.total = action.payload.total;
      state.paginable = action.payload.paginable;
      if (state.histories.length >= action.payload.total) {
        state.endPaging = true;
      }
    },
    getHistoryFailure: handleErrorStopLoading,

    reset: (state, action) => {
      const skipReset = state.goBackFromCustomerInfoPage;
      if (skipReset) return state;

      return action.payload.hard
        ? cloneDeep(initialState)
        : {
            ...cloneDeep(initialState),
            filterTransactionDate: state.filterTransactionDate,
          };
    },

    filterTransactionDateChange: (state, action) => {
      state.filterTransactionDate = action.payload;
      state.histories = [];
      state.paginable = { ...DefaultPaginable };
      state.endPaging = false;
      state.total = 0;
    },

    changeSubscriptionInfo: handleLoading,
    changeSubscriptionInfoSuccess: (state, action) => {
      state.loading = false;

      const history = state.histories.find((h) => h.substId === action.payload.substId);
      if (history.amendChange) {
        history.change = false;
        history.amendChange = false;
      }
    },
    changeSubscriptionInfoFailure: handleErrorStopLoading,

    resendEmail: handleLoading,
    resendEmailSuccess: (state) => {
      state.loading = false;
    },
    resendEmailFailure: handleErrorStopLoading,

    cancelTransaction: handleLoading,
    cancelTransactionSuccess: (state, action) => {
      state.loading = false;
      const history = state.histories.find((h) => h.substId === action.payload.substId);
      if (history) {
        history.cancel = false;
      }
    },
    cancelTransactionFailure: handleErrorStopLoading,

    toggleExpandRow: (state, action) => {
      return Immu.toggle(state, {
        path: "histories.{substId}",
        state: ["expanded"],
        pathParams: action.payload,
      });
    },
  },
});

export const {
  getHistory,
  getHistorySuccess,
  getHistoryFailure,
  changeSubscriptionInfo,
  changeSubscriptionInfoSuccess,
  changeSubscriptionInfoFailure,
  resendEmail,
  resendEmailSuccess,
  resendEmailFailure,
  cancelTransaction,
  cancelTransactionSuccess,
  cancelTransactionFailure,
  toggleExpandRow,
  reset,
  filterTransactionDateChange,
} = slice.actions;

export default slice.reducer;
